/** Normalize API permission arrays to unique positive integer student IDs. */
export function normalizePermissionIds(raw) {
  if (!Array.isArray(raw)) return [];
  const ids = raw
    .map((x) => parseInt(String(x), 10))
    .filter((n) => Number.isFinite(n) && n > 0);
  return [...new Set(ids)];
}

export function permissionIdsEqual(a, b) {
  const na = normalizePermissionIds(a).sort((x, y) => x - y);
  const nb = normalizePermissionIds(b).sort((x, y) => x - y);
  if (na.length !== nb.length) return false;
  return na.every((v, i) => v === nb[i]);
}

/** Student IDs newly added to any permission list (compared to previous saved values). */
export function newlyAddedShareStudentIds(previous, draft) {
  const fields = ['readPermission', 'commentPermission', 'editPermission'];
  const added = new Set();
  for (const key of fields) {
    const oldSet = new Set(normalizePermissionIds(previous?.[key]));
    normalizePermissionIds(draft?.[key]).forEach((id) => {
      if (!oldSet.has(id)) added.add(id);
    });
  }
  return [...added];
}

export function sharePermissionsDirty(previous, draft) {
  const fields = ['readPermission', 'commentPermission', 'editPermission'];
  return fields.some((key) => !permissionIdsEqual(previous?.[key], draft?.[key]));
}

export function readPermissionsFromNote(note) {
  if (!note) {
    return { readPermission: [], commentPermission: [], editPermission: [] };
  }
  return {
    readPermission: normalizePermissionIds(
      note.readPermission ?? note.read_permission
    ),
    commentPermission: normalizePermissionIds(
      note.commentPermission ?? note.comment_permission
    ),
    editPermission: normalizePermissionIds(
      note.editPermission ?? note.edit_permission
    ),
  };
}
